/**
 * @typedef { "Stone" | "DeepBlueSea" | "Axit" | "Blood" | "NotQuiteWhite"
 * | "Leaf" | "Gray3" | "Gray4" | "Gray5" | "Grass" | "Yolk" | "DisabledArrow" | "TextBlue"
 * | "LightGrass" | "Charcoal" | "BgLeaf" | "BgAxit"
 * | "Pending" | "PendingBg" | "Active" | "ActiveBg" | "ExpireSoon" | "ExpireSoonBg"
 * | "Expired" | "ExpiredBg" | "Renewed" | "RenewedBg" | "Canceled" | "CanceledBg"
 * | "Waiting" | "WaitingBg" } customColorNames
 * 
 * @typedef { "grassGlowing" | "userTypeGrass" } customGradientColorName
 */

class Colors {

  /**
   * @typedef {import("IZOX/STATIC/ColorX").color} color
   * 
   */

  /**
   * @type {Object<customColorNames, color>}
   */
  static __custom = {
    Stone: this.RGBA(82, 81, 80, 1),
    DeepBlueSea: this.RGBA(32, 71, 136, 1),
    Axit: this.RGBA(7, 201, 114, 1),
    Blood: this.RGBA(174, 11, 24, 1),
    NotQuiteWhite: this.RGBA(242, 243, 238, 1),
    Leaf: this.RGBA(11, 105, 52, 1),
    Gray3: this.RGBA(130, 130, 130, 1),
    Gray4: this.RGBA(189, 189, 189, 1),
    Gray5: this.RGBA(220, 220, 220, 1),
    Grass: this.RGBA(154, 201, 59, 1),
    Yolk: this.RGBA(255, 225, 29, 1),
    DisabledArrow: this.RGBA(225, 225, 225, 1),
    TextBlue: this.RGBA(0, 73, 109, 1),
    Charcoal: this.RGBA(11, 28, 46, 1),
    LightGrass: this.RGBA(172, 246, 161, 1),
    BgLeaf: this.RGBA(220, 234, 218, 1),
    BgAxit: this.RGBA(209, 255, 234, 1),
    
    //status
    Pending: this.RGBA(174, 11, 24, 1),
    PendingBg: this.RGBA(247, 231, 232, 1),
    Active: this.RGBA(32, 71, 136, 1),
    ActiveBg: this.RGBA(243, 248, 255, 1),
    ExpireSoon: this.RGBA(222, 183, 6, 1),
    ExpireSoonBg: this.RGBA(255, 249, 221, 1),
    Expired: this.RGBA(151, 71, 255, 1),
    ExpiredBg: this.RGBA(248, 243, 255, 1),
    Renewed: this.RGBA(11, 105, 52, 1),
    RenewedBg: this.RGBA(244, 255, 222, 1),
    Canceled: this.RGBA(82, 81, 80, 1),
    CanceledBg: this.RGBA(222, 222, 222, 1),
    Waiting: this.RGBA(255, 137, 29, 1),
    WaitingBg: this.RGBA(255, 220, 187, 1)

  };

  /**
   * @type {Object.<string, [{
  *  percent: Number,
  *  color: color
  * }]}
  */
  static __gradient = {
    grassGlowing: [
      {
        percent: 0,
        color: this.RGBA(255, 255, 255, 1)
      },
      {
        percent: 66.66,
        color: this.RGBA(255, 255, 255, 1)
      },
      {
        percent: 100,
        color: this.RGBA(154, 201, 59, 1),
      },
    ],
    userTypeGrass: [
      {
        percent: 0,
        color: this.RGBA(255, 255, 255, 1)
      },
      {
        percent: 100,
        color: this.RGBA(255, 255, 255, 0.6)
      },
    ]
  };

  /**
   * 
   * @param {Number} r 
   * @param {Number} g 
   * @param {Number} b 
   * @param {Number} a 
   * @returns {color}
   */
  static RGBA(r, g, b, a = 1){
    return {r, g, b, a};
  }

}

export default Colors;